import { HttpBadStatusCodeError, UnknownError } from '@cian/peperrors/shared';

import {
  createGetMainPageBrandBannerEnrichmentsModel,
  fetchGetMainPageBrandBannerEnrichments,
  type IGetMainPageBrandBannerEnrichmentsRequest,
  type TGetMainPageBrandBannerEnrichmentsResponse,
} from 'shared/repositories/ad-banner/v1/get-main-page-brand-banner-enrichments';
import { IApplicationContext } from 'shared/types/applicationContext';
import { IV1GetMainPageBrandBannerEnrichmentsResponse } from 'shared/repositories/ad-banner/entities/get_main_page_brand_banner_enrichments_v1/V1GetMainPageBrandBannerEnrichmentsResponse';

export async function fetchGetMainPageBrandBannerEnrichmentsService(
  applicationContext: IApplicationContext,
  parameters: IGetMainPageBrandBannerEnrichmentsRequest,
): Promise<IV1GetMainPageBrandBannerEnrichmentsResponse> {
  const { httpApi, logger } = applicationContext;

  const domain = 'src/shared/services/fetchGetMainPageBrandBannerEnrichmentsService.ts';

  return fetchGetMainPageBrandBannerEnrichments<
    TGetMainPageBrandBannerEnrichmentsResponse,
    TGetMainPageBrandBannerEnrichmentsResponse
  >({
    httpApi,
    parameters,
  }).then(
    result => {
      const statusCode = result.statusCode;

      switch (result.statusCode) {
        case 200:
          return result.response;
        case 400: {
          const httpBadStatusCodeError = new HttpBadStatusCodeError({
            details: {
              model: JSON.stringify(createGetMainPageBrandBannerEnrichmentsModel(parameters)),
            },
            domain,
            message: `Ошибка в запросе: ${result.response?.message}`,
            statusCode,
          });

          logger.warning(httpBadStatusCodeError.message, {
            details: httpBadStatusCodeError.printDetails(),
            domain: httpBadStatusCodeError.domain,
          });

          throw httpBadStatusCodeError;
        }
        default: {
          const httpBadStatusCodeError = new HttpBadStatusCodeError({
            details: {
              model: JSON.stringify(createGetMainPageBrandBannerEnrichmentsModel(parameters)),
            },
            domain,
            message: `Неизвестный статус ответа: ${statusCode}`,
            statusCode,
          });

          logger.error(httpBadStatusCodeError.message, {
            details: httpBadStatusCodeError.printDetails(),
            domain: httpBadStatusCodeError.domain,
          });

          throw httpBadStatusCodeError;
        }
      }
    },
    error => {
      const unknownError = new UnknownError({
        details: {
          model: JSON.stringify(createGetMainPageBrandBannerEnrichmentsModel(parameters)),
        },
        domain,
        message: 'Неизвестная ошибка в запросе',
      });

      logger.error(error, {
        details: unknownError.printDetails(),
        domain: unknownError.domain,
        message: unknownError.message,
      });

      throw unknownError;
    },
  );
}
